type Props = {
  message?: string
}

const PlanLockNotice = ({ message = "この機能はプロプラン限定です" }: Props) => (
  <div className="plan-lock-notice">
    <i className="bi bi-lock-fill" />
    <p>{message}</p>
  </div>
)

export default PlanLockNotice
